// import '../assets/css/styles.css';

import './js/gallery';

const sectionSliders = document.querySelectorAll('.section-slider');
if (sectionSliders.length > 0) {
    import('./js/slider').then(Slider => {
        new Slider.default();
    }).catch(err => {
        console.error('Failed to load Slider module:', err);
    });
}

const body = document.querySelector('body');
const serviceLinks = document.querySelectorAll('.service-link');
let serviceModal = document.getElementById('serviceModal');
if (serviceLinks.length > 0) {
    // if url has hash with service slug load that service in modal
    if (window.location.hash) {
        let slug = window.location.hash.substring(1);
        let servicesGrid = document.querySelector('.services.grid');
        // let link = where href ends with slug
        let link = Array.from(serviceLinks).find(link => link.href.endsWith(slug));

        if (link) {
            setTimeout(function() {
                servicesGrid.scrollIntoView({ behavior: 'smooth' });
                link.click();
            }, 500);
        }
    }
    let loader = document.querySelector('.loader');
    serviceLinks.forEach(link => {
        link.addEventListener('click', () => {
            loader.classList.remove('hidden');
            let id = link.dataset.id;
            fetch(theme.ajaxurl, {
                method: 'POST',
                body: new URLSearchParams({
                    action: 'load_post_details',
                    id: id
                })
            })
                .then(response => response.text())
                .then(data => {
                    serviceModal.querySelector('.modal-content').innerHTML = data;
                    serviceModal.classList.add('active');
                    body.classList.add('has-layer');
                    loader.classList.add('hidden');
                })
                .catch(err => {
                    console.error('Error loading project slider:', err);
                    body.classList.remove('has-layer');
                    loader.classList.add('hidden');

                });
        });
    });
}



// close modal when clicking outside content or on close button
if (serviceModal) {
    // close modal on pressing escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !serviceModal.classList.contains('hidden')) {
            serviceModal.classList.remove('active');
            body.classList.remove('has-layer');
        }
    });

    let closeButton = serviceModal.querySelector('.close-modal');

    closeButton.addEventListener('click', (e) => {
        serviceModal.classList.remove('active');
        body.classList.remove('has-layer');
    });

}

let portfolioItems = document.querySelectorAll('.portfolio-slider .portfolio-item');
if (portfolioItems.length > 0) {
    let itemDetails = document.getElementById('itemDetails');
    portfolioItems.forEach(item => {
        item.addEventListener('click', (event) => {
            body.classList.add('has-layer');
            ['title', 'year', 'people', 'event'].forEach(field => {
                itemDetails.querySelector(`.${field}`).innerText = item.dataset[field];
            });
            itemDetails.classList.remove('hidden');
            let cursorX = event.clientX;
            let cursorY = event.clientY;

            let itemDetailsWidth = itemDetails.offsetWidth;
            if (cursorX + itemDetailsWidth > window.innerWidth) {
                cursorX = window.innerWidth - itemDetailsWidth - 20;
            }

            itemDetails.style.top = `${cursorY}px`;
            itemDetails.style.left = `${cursorX}px`;

            // if too below then adjust the y position of itemDetails
            let itemDetailsHeight = itemDetails.offsetHeight;
            if (cursorY + itemDetailsHeight > window.innerHeight) {
                cursorY = window.innerHeight - itemDetailsHeight - 20;
                itemDetails.style.top = `${cursorY}px`;
            }
        });
    });

    // itemDetails close on clicking outside or on close button
    itemDetails.querySelector('.close').addEventListener('click', (e) => {
         itemDetails.classList.add('hidden');
        body.classList.remove('has-layer');

    });
    // escape key to close
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !itemDetails.classList.contains('hidden')) {
            itemDetails.classList.add('hidden');
            body.classList.remove('has-layer');
        }
    });
}

// add load more functionality to portfolio grid
let loadMoreButton = document.getElementById('loadMorePortfolio');
if (loadMoreButton) {
    loadMoreButton.addEventListener('click', () => {
        // show all hidden portfolio items
        let hiddenItems = document.querySelectorAll('.portfolio-item.hidden');
        hiddenItems.forEach(item => {
            item.classList.remove('hidden');
        });
        loadMoreButton.classList.add('hidden');
    });
}
